export default {
  // Common
  common: {
    loading: 'Loading...',
    confirm: 'Confirm',
    cancel: 'Cancel',
    save: 'Save',
    edit: 'Edit',
    delete: 'Delete',
    search: 'Search',
    reset: 'Reset',
    submit: 'Submit',
    back: 'Back',
    more: 'More',
    close: 'Close',
    success: 'Success',
    error: 'Error',
    warning: 'Warning',
    info: 'Info'
  },

  // Navigation Menu
  nav: {
    home: 'Home',
    mainBusiness: 'Main Business',
    newEnergy: 'New Energy',
    specialContainer: 'Special Container & Breakbulk',
    europeLine: 'Europe Line',
    southAmericaLine: 'South America Line',
    researchInstitute: 'Aurelia Research Institute',
    caseStudies: 'Case Studies',
    contactUs: 'Contact Us',
    aboutUs: 'About Aurelia',
    contactInfo: 'Contact Information'
  },

  // Home Page
  home: {
    title: 'Aurelia',
    subtitle: '',
    section3Title: 'Industrial Brain will become the standard configuration for industrial development in all cities and parks',
    section4Title1: 'Core Resource Integration Capability',
    section4Title2: 'Multi-industry Global Public Domain Data Accumulation',
    section4Title3: 'Billion-level Industrial Dynamic Ontology',
    section4SubTitle1: 'Backed by China Center for Information Industry Development (CCID), a direct affiliate of Ministry of Industry and Information Technology, with strong industrial resource integration capabilities',
    section4Desc1: 'Supporting the construction of manufacturing power and network power, focusing on key areas such as integration of informatization and industrialization, intelligent manufacturing, digital economy, and civil-military integration, gradually forming 6 major business layouts: research consulting, testing certification, technology services, media exhibitions, military business, and industrial finance, serving over 20 national ministries, 400+ local governments, and 5000+ industry enterprises.',
    section4SubTitle2: 'Completed construction of global public domain data center covering 9 major strategic emerging industries and 70+ sub-sectors',
    section4Desc2: 'Global <span>10,000+</span> official data sources <span>100,000+</span> data collection points',
    section4SubTitle3: 'Keystone industrial dynamic ontology knowledge base, supporting industrial digital intelligence upgrade',
    section5Title: 'Cooperative Clients',
    section5SubTitle: 'Continuously creating unique value for users',
    // Business Introduction
    business: {
      title: 'Core Business',
      subtitle: 'Professional logistics solutions for simpler and more efficient global transportation',
        coreTag: 'Core Business',
      carLogistics: {
        title: 'Automotive & New Energy Logistics',
        description: 'Tailored global integrated logistics solutions for the automotive industry',
        features: [
          'Vehicle transportation safety assurance',
          'Professional handling of new energy vehicles',
          'Global logistics network coverage',
          'Real-time tracking system'
        ]
      },
      energyLogistics: {
        title: 'New Energy Logistics Solutions',
        description: 'Comprehensive transportation services for energy storage products exported overseas',
        features: [
          'Professional packaging for energy storage products',
          'Multimodal transportation solutions',
          'Customs clearance service support',
          'Overseas distribution network'
        ]
      },
      solarLogistics: {
        title: 'Photovoltaic Module Transportation',
        description: 'Global transportation services for solar panels and related accessories',
        features: [
          'Professional protection for PV modules',
          'Global installation point distribution',
          'Renewable energy support',
          'Environmentally friendly transportation solutions'
        ]
      },
      containerLogistics: {
        title: 'Reefer as Dry Container Transportation',
        description: 'Optimized transportation solutions using refrigerated containers as dry cargo',
        features: [
          'Seasonal space optimization',
          'Cost control solutions',
          'NOR professional operations',
          'Temperature monitoring system'
        ]
      },
      steelLogistics: {
        title: 'Steel Coil Product Logistics',
        description: 'Professional handling and transportation solutions for steel logistics',
        features: [
          'Professional steel coil securing',
          'Weight balance control',
          'Anti-rolling measures',
          'Professional loading/unloading equipment'
        ]
      }
    }
  },

  // New Energy Page
  newEnergy: {
    bannerTitle: 'New Energy Vehicle Transportation',
    bannerSubtitle: 'Safe, Efficient, Compliant Global Logistics Solutions',
    bannerDescription: 'Providing professional global transportation services for new energy vehicles for automotive manufacturers, covering full-chain transportation modes, end-to-end logistics services, and specialized vehicle handling',
    features: {
      title: 'Core Advantages',
      item1: 'Professional Team',
      item2: 'Global Network',
      item3: 'Compliance Assurance',
      item4: 'Safety Guarantee'
    },
    services: {
      title: 'Service Content',
      item1: 'Vehicle Transportation',
      item2: 'Warehouse Management',
      item3: 'Customs Clearance',
      item4: 'Insurance Services'
    },
    // Case Page
    case: {
      background: 'Project Background',
      challenges: 'Core Challenges',
      solution: 'Professional Solutions',
      process: 'Key Operation Process',
      imageGallery: 'Case Image Gallery',
      results: 'Project Results',
      value: 'Professional Value'
    },
    // Production Brain Page
    production: {
      coreBusiness: {
        title: '🚗 Core Business Scope of New Energy Vehicle Transportation',
        subtitle: 'Professional logistics services for safer and more efficient new energy vehicle transportation'
      },
      keyChallenges: {
        title: '⚡ Key Challenges and Professional Responses in New Energy Vehicle Transportation',
        subtitle: 'Addressing special requirements of new energy vehicle transportation to ensure safety and compliance'
      },
      safetyGuarantees: {
        title: '🛡️ Safety and Professional Guarantees',
        subtitle: 'Comprehensive protection for the safety and quality of new energy vehicle transportation'
      },
      greenPractices: {
        title: '🌱 Green Logistics Practices',
        subtitle: 'Responding to the environmental attributes of the new energy industry, creating green transportation solutions'
      },
      serviceProcess: {
        title: '📋 Typical Service Process',
        subtitle: 'Professional full-process logistics service for new energy vehicle export'
      }
    }
  },

  // Special Container & Breakbulk Page
  specialContainer: {
    bannerTitle: 'Special Container & Breakbulk Transportation',
    bannerSubtitle: 'Professional Breakbulk Transportation Solutions, Global Network Coverage',
    bannerDescription: 'Our company has professional breakbulk transportation fleet resources, including 5 heavy lift vessels (combined lifting capacity from 200T to 800T), totaling 20 breakbulk vessels, mainly distributed on South America, India-Pakistan, Middle East, Europe and other routes.',
    features: {
      title: 'Core Advantages',
      item1: 'Professional Equipment',
      item2: 'Rich Experience',
      item3: 'Global Network',
      item4: 'Safety Assurance'
    },
    services: {
      title: 'Service Content',
      item1: 'Special Container Transportation',
      item2: 'Breakbulk Cargo Transportation',
      item3: 'Project Logistics',
      item4: 'Engineering Logistics'
    },
    // Service Advantages
    advantages: {
      title: 'Service Advantages',
      subtitle: 'Professional, Safe, and Efficient Logistics Solutions'
    },
    // Case Page
    case: {
      challenge: 'Client Background and Challenges',
      solution: 'Our Professional Solutions',
      imageGallery: 'Case Image Gallery',
      results: 'Results and Value',
      specifications: 'Technical Specifications',
      noSolutionData: 'No solution data available',
      // Solution titles
      solutionTypeSelection: 'Container Type Selection',
      professionalLoading: 'Professional Loading Solution',
      transportationSafety: 'Transportation Safety Assurance',
      timeManagement: 'Time Management',
      routePlanning: 'Route Planning',
      professionalSolution: 'Professional Solution',
      professionalTransportation: 'Professional Transportation Solution',
      // Result titles
      safeEfficientDelivery: 'Safe and Efficient Delivery',
      customerSatisfaction: 'High Customer Satisfaction',
      professionalRecognition: 'Professional Service Recognition',
      successCase: 'Success Case',
      excellentResults: 'Excellent Results',
      successfulDelivery: 'Successful Delivery',
      // Technical specification labels
      containerType: 'Container Type',
      equipmentWeight: 'Equipment Weight',
      equipmentHeight: 'Equipment Height',
      transportationTime: 'Transportation Time',
      route: 'Route'
    }
  },

  // Europe Line Page
  europeLine: {
    title: 'Europe Line',
    subtitle: 'Connecting China and Europe, facilitating trade, supporting enterprise globalization',
    introduction: {
      title: 'Route Introduction',
      description: 'Professional Europe line logistics services, connecting China-Europe trade bridge'
    },
    network: {
      title: 'Route Network',
      description: 'Covering major European ports and cities, providing efficient logistics solutions'
    },
    advantages: {
      title: 'Service Advantages',
      description: 'Professional, efficient, and reliable Europe line logistics services'
    },
    services: {
      title: 'Service Content',
      description: 'Comprehensive logistics solutions to meet different customer needs'
    }
  },

  // South America Line Page
  southAmericaLine: {
    title: 'South America Line',
    subtitle: 'Connecting China and South America, facilitating trade, supporting enterprise globalization',
    introduction: {
      title: 'Route Introduction',
      description: 'Professional South America line logistics services, connecting China-South America trade bridge'
    },
    network: {
      title: 'Route Network',
      description: 'Covering major South American ports and cities, providing efficient logistics solutions'
    },
    advantages: {
      title: 'Service Advantages',
      description: 'Professional, efficient, and reliable South America line logistics services'
    },
    services: {
      title: 'Service Content',
      description: 'Comprehensive logistics solutions to meet different customer needs'
    }
  },

  // Case Studies
  caseStudies: {
    title: 'Case Studies',
    newEnergyCases: 'New Energy Cases',
    specialContainerCases: 'Special Container Cases',
    industryReports: 'Industry Reports'
  },

  // Contact Us
  contact: {
    title: 'Contact Us',
    phone: 'Phone',
    email: 'Email',
    address: 'Address',
    wechat: 'WeChat',
    workingHours: 'Working Hours',
    contactInfo: 'Contact Information',
    companyName: 'Company Name',
    contactPerson: 'Contact Person',
    message: 'Message',
    send: 'Send'
  },

  // Footer
  footer: {
    copyright: 'Copyright ©2025 Aurelia . All Rights Reserved .',
    icp: 'Shanghai ICP No. 88888888-1 Shanghai Public Security No. 31088888888888',
    links: 'Friendship Links',
    contactUs: 'Contact Us',
    followUs: 'Follow Us'
  },

  // Error Pages
  error: {
    404: 'Page Not Found',
    500: 'Server Error',
    goHome: 'Back to Home'
  },

  // Form Validation
  validation: {
    required: 'This field is required',
    email: 'Please enter a valid email address',
    phone: 'Please enter a valid phone number',
    minLength: 'Length cannot be less than {min} characters',
    maxLength: 'Length cannot exceed {max} characters'
  },

  // Company Introduction
  company: {
    introduction: {
      title: 'Company Introduction',
      subtitle: 'Professional Logistics Services, Global Network Coverage',
      name: 'Shanghai Aurelia Supply Chain Management Co., Ltd.',
      established: 'Established in {year}',
      description: 'Shanghai Aurelia Supply Chain Management Co., Ltd. was founded in 2013 and is a comprehensive logistics service provider that can handle import and export business at all ports and barge terminals nationwide. Headquartered in Hongkou District, Shanghai, with branches and offices in Qingdao/Jiaxing/Shenzhen/Ningbo, we are familiar with import and export cargo transportation in major ports and cities across the country, including sea freight, air freight, sea-air combined transport, breakbulk cargo transportation and other businesses, and provide customers with one-stop services such as customs clearance, commodity inspection, insurance, warehousing, and trucking.',
      partners: {
        title: 'Partners',
        description: 'We gather global top shipping resources, including CMA, MAERSK, MSC, COSCO, HAPAG-LLOYD, EVERGREEN, WHL, PIL, OOCL, ONE, YML, ZIM among the top 20 shipping companies have established stable cooperative relationships. This not only builds our strong service network, but also ensures that we can provide you with the most optimized choice on any route. From industry giants Maersk, MSC, to regional experts Wan Hai Shipping, ZIM Shipping, our cooperation network covering all echelon shipping companies gives us unparalleled flexibility and customization capabilities, enabling us to accurately match the most suitable shipowner resources for customers with different cargo types and different route requirements.'
      },
      advantages: {
        title: 'Service Advantages',
        experiencedTeam: 'Experienced Operation Team',
        experiencedTeamDesc: 'Professional team with years of logistics industry experience',
        capacityControl: 'Significant Capacity Control Capability',
        capacityControlDesc: 'Maintaining good cooperative relationships with major shipping companies',
        agentNetwork: 'Extensive Agent Network',
        agentNetworkDesc: 'Domestic and overseas agent network covering major ports worldwide',
        routeArrangement: 'Flexible Optimal Route Arrangement',
        routeArrangementDesc: 'Customizing optimal transportation solutions according to customer needs'
      },
      services: {
        title: 'Service Scope',
        transportation: 'Transportation Methods',
        transportationItems: ['Sea Freight', 'Air Freight', 'Land Transport', 'Railway', 'Multimodal Transport', 'Breakbulk Transport'],
        supporting: 'Supporting Services',
        supportingItems: ['Customs Clearance', 'Commodity Inspection', 'Insurance', 'Warehousing', 'Trucking'],
        extended: 'Extended Services',
        extendedItems: ['Chartering & Booking', 'Document Preparation', 'Shipping Schedule', 'Freight Inquiry', 'Insurance Agency'],
        network: 'Network Services',
        networkItems: ['Railway Transport', 'Road Transit', 'Overseas Network', 'Inland Extension Services']
      }
    }
  }
}
